const initQueueCardActions = container => {
  if (!container) return;

  container.addEventListener("click", event => {
    const button = event.target.closest(".js-printer-queue-action");
    if (!button) return;

    const { action, orderId, shipmentId, signalType, signalId } = button.dataset;
    if (!orderId || !shipmentId) return;

    container.dispatchEvent(
      new CustomEvent("printer-queue:signal-change-action", {
        detail: {
          action,
          orderId,
          shipmentId,
          signalType,
          signalId,
          button
        }
      })
    );
  });
};

export default initQueueCardActions;
